import styled from "styled-components";
import { PageContainer } from "@/components/page-container";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import RedWarnIcon from "@/assets/icons/profile/red-warn";
import { Button, Form, Input, Switch } from "@renderbus/ui";
import { DeveloperStoreProvider } from "./store/developer-store";
import { useDeveloperStore } from "./store/developer-store";
import { useGlobalStore } from "@/store/GlobalStore";
import { useDeveloper } from "./hooks/useDeveloper";
import { Modal } from "@/components/renderbus-modal";
import { VerifyModal } from "./components/verify-modal";
import dayjs from "dayjs";

export function DeveloperView() {
  const t = getTranslateNsT("center");
  const { access, hasAccess, loading } = useDeveloperStore();
  const {
    handleSwitch,
    sendUrl,
    form,
    createAccessKey,
    deleteAccessKey,
    handleShowAccessKey,
    openVerifyModal,
    setOpenVerifyModal,
    openCloseServiceModal,
    setOpenCloseServiceModal,
    changeAccessKeyState,
    verifyForm,
    accessKeyInfo,
    handleSubmitVerify,
    url,
  } = useDeveloper();
  const { isDomestic } = useGlobalStore();

  return (
    <PageContainer>
      {!loading && (
        <DeveloperPageContainer>
          <Tip>
            <RedWarnIcon />
            {!hasAccess &&
              t(
                `${
                  isDomestic
                    ? "user_accessKey_close_prompt"
                    : "user_accessKey_close_prompt_fox"
                }`
              )}
            {hasAccess && (
              <div>
                <span>
                  {isDomestic
                    ? t("user_api_title_1")
                    : t("user_api_title_1_fox")}
                </span>
                <a
                  href={
                    isDomestic
                      ? "https://renderbus.readthedocs.io/zh-cn/latest/index.html"
                      : "https://foxrenderfarm.readthedocs.io/en/latest/"
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  Github
                </a>
                <span>{t("user_api_title_2")}</span>
              </div>
            )}
          </Tip>
          {hasAccess && !access && (
            <>
              <Button type="primary" onClick={createAccessKey}>
                {t("user_button_create_key")}
              </Button>
            </>
          )}
          {hasAccess && access && (
            <Form
              form={form}
              colon={false}
              labelCol={{ span: 2 }}
              labelAlign="right"
            >
              <Form.Item label={t("developer_service")}>
                <Row>
                  <Switch
                    checked={Boolean(access.allowAccess)}
                    onChange={handleSwitch}
                  />
                  {!access.allowAccess && (
                    <Button
                      type="text"
                      className="red"
                      onClick={deleteAccessKey}
                    >
                      {t("user_button_delete")}
                    </Button>
                  )}
                </Row>
              </Form.Item>
              {Boolean(access.allowAccess) && (
                <>
                  <Form.Item label={"AccessID"}>
                    <Row>{access.accessId}</Row>
                  </Form.Item>
                  <Form.Item label={"AccessKey"}>
                    <Row>
                      <span className="access-key">
                        {access.accessKey
                          ? access.accessKey
                          : "**************************"}
                      </span>
                      <Button
                        type="text"
                        className="green"
                        onClick={handleShowAccessKey}
                      >
                        {t(
                          access.accessKey
                            ? "user_accessKey_hide"
                            : "user_accessKey_show"
                        )}
                      </Button>
                    </Row>
                  </Form.Item>
                  <Form.Item label={t("user_accessKey_create_time")}>
                    <Row>
                      {dayjs(access.createDate).format("YYYY-MM-DD HH:mm:ss")}
                    </Row>
                  </Form.Item>
                  <Form.Item label={t("user_accessKey_status")}>
                    <Row>
                      {access.allowAccess && <Point />}
                      {access.allowAccess
                        ? t("user_accessKey_using")
                        : t("user_accessKey_disabled")}
                    </Row>
                  </Form.Item>
                  <Form.Item label={t("user_callback_url")} name="url">
                    <Row>
                      <Input
                        placeholder={t("user_callback_url_placeholder")}
                        size="middle"
                      />
                      <Button
                        ghost
                        size="middle"
                        disabled={!url}
                        onClick={sendUrl}
                      >
                        {t("user_button_send_url")}
                      </Button>
                    </Row>
                  </Form.Item>
                </>
              )}
            </Form>
          )}
        </DeveloperPageContainer>
      )}
      <Modal
        open={openCloseServiceModal}
        title={t("common_store_global_dialog_default_title")}
        children={t("user_confirm_api")}
        onCancel={() => setOpenCloseServiceModal(false)}
        onOk={() => changeAccessKeyState(false)}
      />
      <VerifyModal
        open={openVerifyModal}
        form={verifyForm}
        accessKeyInfo={accessKeyInfo}
        modalProps={{
          title: t("common_store_global_dialog_default_title"),
          onCancel: () => {
            setOpenVerifyModal(false);
            verifyForm.resetFields();
          },
          onOk: () => handleSubmitVerify(isDomestic),
        }}
      />
    </PageContainer>
  );
}

export function Developer() {
  return (
    <DeveloperStoreProvider>
      <DeveloperView />
    </DeveloperStoreProvider>
  );
}

const Point = styled.div`
  width: 6px;
  height: 6px;
  background: var(--main-color);
  border-radius: 50%;
  margin-right: 8px;
`;
const Row = styled.div`
  display: flex;
  align-items: center;
  button {
    font-size: 14px;
    &.red {
      color: #ff4444;
      &:hover,
      &:focus {
        color: #ff4444;
      }
    }
    &.green {
      color: var(--main-color);
      &:hover,
      &:focus {
        color: var(--main-color);
      }
    }
  }
  input {
    width: 360px !important;
    margin-right: 16px !important;
  }
  .access-key {
    min-width: 152px;
  }
`;

const DeveloperPageContainer = styled.div`
  padding: 24px;
  min-width: 1660px;
  .ant-form-item,
  .ant-form-item-label label {
    color: rgba(255, 255, 255, 0.85) !important;
  }
  .ant-form-item {
    margin-bottom: 10px;
  }
  .ant-form-item-label label {
    heigth: max-content;
  }
`;

const Tip = styled.div`
  min-height: 40px;
  background: rgba(255, 68, 68, 0.1);
  border: 1px solid rgba(255, 68, 68, 0.26);
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  gap: 6.5px;
  color: #ff4444;
  margin-bottom: 25px;
  div a {
    margin-right: 5px;
    color: #308fff;
    &:hover {
      color: #308fff;
    }
  }
`;
